<template>
  <div class="budget-entity-panel__learn-more">
    <div class="budget-entity-panel__learn-more--header" @click="toggle">
      <span>Learn more</span> about those entity types
      <v-icon :class="{ 'budget-entity-panel__learn-more--rotated': showLearnMoreText }">
        mdi-chevron-down
      </v-icon>
    </div>
    <v-expand-transition>
      <div v-show="showLearnMoreText" class="budget-entity-panel__learn-more--text">
        <div class="budget-entity-panel__learn-more--type">
          <div class="budget-entity-panel__learn-more--title">Standard Budget Entity</div>
          <div class="budget-entity-panel__learn-more--info">
            <div class="budget-entity-panel__learn-more--description">
              Use a Standard Budget Entity to allocate funds to team members who send gifts on
              behalf of the company.
            </div>
            <div class="budget-entity-panel__learn-more--details">
              This budget type lets admins set spend policies for users who will purchase gifts on
              behalf of the company, making it ideal for controlled, program-based spend.
            </div>
            <div class="budget-entity-panel__learn-more--details">
              Standard budget entity key features:
              <ul>
                <li>Manage distributed budget between team members</li>
                <li>Set periodic spend limit per user (e.g. $100 monthly)</li>
                <li>Set spend limit per order Apply approval flows for purchases</li>
                <li>Ensure consistent budget tracking and financial oversight</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="budget-entity-panel__learn-more--type">
          <div class="budget-entity-panel__learn-more--title">Recognition Budget Entity</div>
          <div class="budget-entity-panel__learn-more--info">
            <div class="budget-entity-panel__learn-more--description">
              Use a Recognition Budget Entity to give employees credit to choose their own gifts.
            </div>
            <div class="budget-entity-panel__learn-more--details">
              This budget type is designed for recognition moments — giving users a balance to pick
              their own gift.
            </div>
            <div class="budget-entity-panel__learn-more--details">
              Recognition budget entity key features:
              <ul>
                <li>Manage a single budget to recognize team members</li>
                <li>Give employees credit instantly to buy gifts for themselves</li>
                <li>Trigger automated recognition from HR or point-based systems</li>
                <li>Ensure consistent budget tracking and financial oversight</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'LearnMoreEntityTypes',
  data() {
    return {
      showLearnMoreText: false,
    };
  },
  methods: {
    toggle() {
      this.showLearnMoreText = !this.showLearnMoreText;
    },
  },
};
</script>
